import React, { Component, Fragment, useEffect, useState } from 'react';
import { Query } from 'react-apollo';
import { Redirect } from 'react-router';

import { DrawerTarget } from '@jetshop/ui/Modal/Drawer';

import { FlyoutTarget } from '@jetshop/ui/Modal/Flyout';

import t from '@jetshop/intl';

import MultiListFlyouts from '@jetshop/ui/Filter/FilterTypes/Multi/MultiListFlyouts';

import FilterContext from '@jetshop/core/components/Filters/FilterContext';
import { ModelSelectorConsumer } from '../ModelSelectorProvider';

import { SelectDropdown as BaseDropdown } from '@jetshop/ui/Select';

import GET_CATEGORY from '../Category.gql';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Above, Below } from '@jetshop/ui/Breakpoints';
import { cx } from 'react-emotion';
import { ClearButton, FilterToggler } from '../../CategoryPage/Filters/Filter';
import Button from '../../ui/Button';
import * as Styled from './styles';

library.add(faTimes);

class CategorySelector extends Component {
  render() {
    const { selectCategory, modelCategory } = this.props;
    const availableCats = [
      { value: 106, text: 'Snöskoter' },
      { value: 201, text: 'Cross' },
      { value: 3444, text: 'ATV' },
      { value: 454, text: 'Motorcykel' },
    ];
    let selectedCat = {};
    for (var i = 0; i < availableCats.length; i++) {
      if (availableCats[i].value === parseInt(modelCategory)) {
        selectedCat = availableCats[i];
      }
    }
    return (
      <FilterContext.Consumer>
        {({ clearFilters }) => (
          <BaseDropdown
            items={availableCats}
            title={selectedCat ? selectedCat.text : 'Select Category'}
            onChange={(e) => {
              if (!e) {
                return;
              }
              if (e.value !== modelCategory) {
                clearFilters();
              }
              selectCategory(e.value);
            }}
            defaultSelectedItem={selectedCat}
          />
        )}
      </FilterContext.Consumer>
    );
  }
}

export class FilterQuery extends Component {
  state = {
    shouldRedirect: false,
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.activeFilter !== this.props.activeFilter &&
      this.props.activeFilter.multiListFilters.length > 0 &&
      this.props.activeFilter.multiListFilters[0].values.length === 3
    ) {
      this.props.turnOnFilter();
      if (prevProps.activeFilter.multiListFilters.length > 0) {
        if (
          this.props.activeFilter.multiListFilters[0].values[2] !==
          prevProps.activeFilter.multiListFilters[0].values[2]
        ) {
          this.setState({ shouldRedirect: true });
        }
      } else {
        this.setState({ shouldRedirect: true });
      }
    }
  }

  sortYears(a, b) {
    if (parseFloat(a.value) > parseFloat(b.value)) {
      return -1;
    } else {
      return 1;
    }
  }

  sortFilters(filters) {
    var multiListIndex = filters.findIndex(
      (f) => f.__typename === 'MultiListFilter'
    );
    var multiList = filters.filter((f) => f.__typename === 'MultiListFilter');

    if (multiList.length > 0) {
      var yearIndex = multiList[0].lists.findIndex(
        (f) => f.name === 'Årsmodell'
      );
      var year = multiList[0].lists.filter((f) => f.name === 'Årsmodell');
      if (yearIndex > -1) {
        var yearItems = [];
        for (var i = 0; i < year[0].items.length; i++) {
          yearItems.push({
            value: year[0].items[i].value,
            text: year[0].items[i].text,
            resultCount: year[0].items[i].resultCount,
            __typename: year[0].items[i].__typename,
          });
        }
        var yearObject = {
          name: year[0].name,
          items: yearItems.sort(this.sortYears),
          typename: year[0].__typename,
        };

        var multiListObject = {
          id: multiList[0].id,
          lists: [multiList[0].lists[0], yearObject, multiList[0].lists[2]],
          name: multiList[0].name,
          __typename: multiList[0].__typename,
        };
      }
      var filtersObject = [];
      if (multiListObject) {
        for (var j = 0; j < filters.length; j++) {
          if (j === multiListIndex) {
            filtersObject.push(multiListObject);
          } else {
            filtersObject.push(filters[j]);
          }
        }
      } else {
        return filters;
      }
    }

    return filtersObject;
  }

  render() {
    const {
      modelCategory,
      activeFilter,
      applyFilter,
      selectCategory,
      redirectUrl,
      removeRedirect,
      hideTarget,
      clearFilters,
      applyAllFilters,
      toggleFilter,
    } = this.props;

    return (
      <React.Fragment>
        <Styled.OptionsWrapper>
          <Styled.ModelFlyoutTitle>Välj modell</Styled.ModelFlyoutTitle>
          <div className="flex">
            <CategorySelector
              selectCategory={selectCategory}
              modelCategory={modelCategory}
            />

            <Query
              query={GET_CATEGORY}
              variables={{ modelCategory, activeFilter }}
              fetchPolicy="network-only"
            >
              {({ loading, error, data }) => {
                if (loading) {
                  return (
                    <React.Fragment>
                      <Styled.FakeSelect>Märke</Styled.FakeSelect>
                      <Styled.FakeSelect>Årsmodell</Styled.FakeSelect>
                      <Styled.FakeSelect>Modell</Styled.FakeSelect>
                    </React.Fragment>
                  );
                }
                if (error) return error;
                var filters = this.sortFilters(data.category.products.filters);

                return (
                  <React.Fragment>
                    <MultiListFlyouts
                      filters={filters}
                      result={data.category.products.result}
                      activeFilter={{ multiListFilters: [activeFilter] }}
                      applyFilter={applyFilter}
                    />
                    <Below breakpoint="md">
                      <FilterToggler
                        clearFilters={clearFilters}
                        activeFilters={activeFilter}
                        applyFilters={applyAllFilters}
                        flyout={true}
                        toggleFilter={toggleFilter}
                        filters={data.category.products.filters}
                      />
                    </Below>
                    <ClearButton
                      onClick={() => {
                        clearFilters();
                        if (
                          typeof window !== 'undefined' &&
                          typeof window.localStorage !== 'undefined'
                        ) {
                          localStorage.removeItem('savedFilter');
                        }
                      }}
                      className="clear-filters"
                    >
                      <FontAwesomeIcon icon={['fal', 'times']} />
                    </ClearButton>

                    {activeFilter.multiListFilters.length > 0 &&
                      activeFilter.multiListFilters[0].values.length === 3 &&
                      this.state.shouldRedirect &&
                      shouldRedirect(
                        redirectUrl,
                        removeRedirect,
                        hideTarget
                      ) && <Redirect to={redirectUrl} />}
                  </React.Fragment>
                );
              }}
            </Query>
          </div>
        </Styled.OptionsWrapper>
      </React.Fragment>
    );
  }
}

function shouldRedirect(redirectUrl, removeRedirect, hide) {
  hide();
  if (
    typeof window !== 'undefined' &&
    window.location.href.indexOf(redirectUrl) < 0
  ) {
    if (redirectUrl) {
      removeRedirect();
    }

    return true;
  }
}

const ModelFlyoutView = ({ modal, ...rest }) => {
  const [garageEntries, setGarageEntries] = useState([]);

  useEffect(() => {
    const garage = JSON.parse(localStorage.getItem('garage'));
    if (garage) {
      setGarageEntries(garage);
    } else {
      setGarageEntries([]);
    }
  }, []);

  function checkIfGarageItemExists(garageItem) {
    const garage = JSON.parse(localStorage.getItem('garage'));
    if (garage) {
      return garage.find((item) => {
        return (
          item.category === garageItem.category &&
          item.brand === garageItem.brand &&
          item.year === garageItem.year &&
          item.model === garageItem.model
        );
      });
    }
    return false;
  }

  return (
    <FilterContext.Consumer>
      {({
        applyMultiFilter,
        activeFilters,
        onFilterChange,
        clearFilters,
        applyFilters,
        applyListFilter,
      }) => {
        return (
          <ModelSelectorConsumer>
            {({
              selectCategory,
              modelCategory,
              redirectUrl,
              removeRedirect,
              toggleFilter,
              turnOnFilter,
            }) => (
              <Styled.Flyout {...rest}>
                <Styled.Header url={redirectUrl}>
                  <Above breakpoint="md">
                    <>
                      <Styled.HeaderTitle>Välj din maskin</Styled.HeaderTitle>
                      <Styled.CloseModal onClick={modal.hideTarget}>
                        <Styled.EmptyButtonIcon icon={['fal', 'times']} />{' '}
                      </Styled.CloseModal>
                    </>
                  </Above>
                </Styled.Header>
                {activeFilters.multiListFilters &&
                  activeFilters.multiListFilters.length > 0 &&
                  activeFilters.multiListFilters[0].values.length === 3 && (
                    <Styled.SelectedModel>
                      <span>
                        {activeFilters.multiListFilters[0].values[0]}{' '}
                        {activeFilters.multiListFilters[0].values[1]}{' '}
                        {activeFilters.multiListFilters[0].values[2]}
                      </span>
                      <Styled.ButtonWrapper>
                        <Button
                          variant="outline"
                          widthAuto
                          disabled={checkIfGarageItemExists({
                            category: redirectUrl,
                            brand: activeFilters.multiListFilters[0].values[0],
                            year: activeFilters.multiListFilters[0].values[1],
                            model: activeFilters.multiListFilters[0].values[2],
                          })}
                          onClick={() => {
                            let garage = JSON.parse(
                              localStorage.getItem('garage')
                            );

                            if (!garage) {
                              garage = [];
                            }
                            const garageItem = {
                              category: redirectUrl,
                              brand:
                                activeFilters.multiListFilters[0].values[0],
                              year: activeFilters.multiListFilters[0].values[1],
                              model:
                                activeFilters.multiListFilters[0].values[2],
                            };

                            const itemExists = checkIfGarageItemExists(
                              garageItem
                            );
                            if (!itemExists) {
                              garage.push(garageItem);
                              setGarageEntries(garage);
                              localStorage.setItem(
                                'garage',
                                JSON.stringify(garage)
                              );
                            }
                          }}
                        >
                          Spara i garage
                        </Button>
                        <Button
                          anchor
                          widthAuto
                          onClick={() => {
                            if (
                              typeof window !== 'undefined' &&
                              typeof window.localStorage !== 'undefined'
                            ) {
                              localStorage.removeItem('savedFilter');
                            }
                          }}
                          href={
                            redirectUrl
                              ? `${redirectUrl}?brand=${activeFilters.multiListFilters[0].values[0]}&year=${activeFilters.multiListFilters[0].values[1]}&model=${activeFilters.multiListFilters[0].values[2]}`
                              : '/'
                          }
                        >
                          Visa alla delar
                        </Button>
                      </Styled.ButtonWrapper>
                    </Styled.SelectedModel>
                  )}

                {modal.isOpen && (
                  <FilterQuery
                    onFilterChange={onFilterChange}
                    activeFilter={activeFilters}
                    applyFilter={applyMultiFilter}
                    modelCategory={modelCategory}
                    selectCategory={selectCategory}
                    redirectUrl={redirectUrl}
                    removeRedirect={removeRedirect}
                    hideTarget={modal.hideTarget}
                    clearFilters={clearFilters}
                    applyAllFilters={applyFilters}
                    toggleFilter={toggleFilter}
                    turnOnFilter={turnOnFilter}
                  />
                )}
                {garageEntries.length > 0 && (
                  <Styled.Garage>
                    <Styled.HeaderTitle>Ditt garage</Styled.HeaderTitle>
                    <Styled.GarageList>
                      {garageEntries.map((item, index) => {
                        return (
                          <Styled.GarageItem key={index}>
                            <Styled.GarageName>
                              {item.brand} {item.year} {item.model}
                            </Styled.GarageName>
                            <div className={cx(Styled.flex)}>
                              <Button
                                anchor
                                widthAuto
                                variant="outline"
                                onClick={() => {
                                  let garage = JSON.parse(
                                    localStorage.getItem('garage')
                                  );

                                  const updatedGarage = garage.filter(
                                    (garageItem) => {
                                      return (
                                        item.category !== garageItem.category ||
                                        item.brand !== garageItem.brand ||
                                        item.year !== garageItem.year ||
                                        item.model !== garageItem.model
                                      );
                                    }
                                  );
                                  setGarageEntries(updatedGarage);
                                  localStorage.setItem(
                                    'garage',
                                    JSON.stringify(updatedGarage)
                                  );
                                }}
                              >
                                Ta bort
                              </Button>
                              <Button
                                anchor
                                widthAuto
                                onClick={() => {
                                  if (
                                    typeof window !== 'undefined' &&
                                    typeof window.localStorage !== 'undefined'
                                  ) {
                                    localStorage.removeItem('savedFilter');
                                  }
                                }}
                                href={
                                  item.category
                                    ? `${item.category}?brand=${item.brand}&year=${item.year}&model=${item.model}`
                                    : '/'
                                }
                              >
                                Visa alla delar
                              </Button>
                            </div>
                          </Styled.GarageItem>
                        );
                      })}
                    </Styled.GarageList>
                  </Styled.Garage>
                )}
              </Styled.Flyout>
            )}
          </ModelSelectorConsumer>
        );
      }}
    </FilterContext.Consumer>
  );
};

const ModelFlyout = (props) => (
  // Wrap the flyout with the needed providers
  <Fragment>
    <FlyoutTarget id="model-flyout">
      {(flyout) => <ModelFlyoutView modal={flyout} {...props} />}
    </FlyoutTarget>

    <DrawerTarget id="model-drawer">
      {(drawer) => (
        <Styled.StyledDrawer isOpen={drawer.isOpen} right>
          <Styled.MenuTitle onClick={drawer.hideTarget}>
            <Styled.CloseIcon icon={['fal', 'times']} /> {t('Close')}
          </Styled.MenuTitle>
          <ModelFlyoutView modal={drawer} {...props} />
        </Styled.StyledDrawer>
      )}
    </DrawerTarget>
  </Fragment>
);

export default ModelFlyout;
